module.exports = __webpack_public_path__ + "img/Bodice-Back-Ja-Kk-Lb.0e63f0e8.png";